import { useState } from "react";
import { Input, Radio, RadioGroup } from "rsuite";

export function TravelInsurance({ data, onChange }) {
  const [travelInsurance, setTravelInsurance] = useState("No");

  return (
    <>
      <div className="card containerd w-75">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2>Travel Insurance Details</h2>
        </div>
        <div className="card-body p-3 ">
          <label style={{ fontSize: 14, marginBottom: 10 }}>
            I require travel insurance
          </label>
          <RadioGroup
            name="insurance"
            onChange={(value) => {
              if (value == "Yes") {
                setTravelInsurance("Yes");
                onChange("travel_insurance", "Yes");
              } else {
                setTravelInsurance("No");
                onChange("travel_insurance", "");
              }
            }}
            // onChange={(value) => onChange("travel_insurance", value)}
            defaultValue={
              data?.travel_insurance ? data?.travel_insurance : "Yes"
            } // Set the default value to 'No' or 'Yes' based on your requirement
          >
            <Radio value="Yes">Yes</Radio>
            <Radio value="No">No</Radio>
          </RadioGroup>

          {travelInsurance == "No" && (
            <Input
              className="mb-2"
              title={"please provide insurance provider"}
              label={"please provide insurance provider"}
              placeholder={"Please provide insurance provider"}
              type={"text"}
              onChange={(value) => onChange("travel_insurance", value)}
              value={data?.travel_insurance}
            />
          )}
        </div>
      </div>
    </>
  );
}
